/** Hands a file to the browser (a blob URL — CSP img/connect rules don't apply to a download link). */
export function saveBlob(fileName: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1_000);
}

/** "auditplus-<what>.<ext>" — letters/digits/dashes only. */
export function exportFileName(what: string, ext: string): string {
  const slug = what.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '') || 'export';
  return `auditplus-${slug}.${ext}`;
}
